
import { Button } from "@/components/ui/button";
import { useIsMobile } from "@/hooks/use-mobile";
import { ColorPreset } from "@/contexts/theme/ThemeContext";

export const colorOptions: ColorPreset[] = [
  { name: "Default", primary: "#2C3E50", accent: "#3D5A74" },
  { name: "Purple", primary: "#7E57C2", accent: "#9575CD" },
  { name: "Teal", primary: "#26A69A", accent: "#4DB6AC" },
  { name: "Blue", primary: "#1e40af", accent: "#3b82f6" },
  { name: "Green", primary: "#15803d", accent: "#22c55e" },
];

interface ColorPresetsProps {
  onSelectPreset: (preset: ColorPreset) => void;
}

const ColorPresets = ({ onSelectPreset }: ColorPresetsProps) => {
  const isMobile = useIsMobile();

  return (
    <>
      {colorOptions.map((color) => (
        <Button
          key={color.name}
          variant="outline"
          className="justify-start"
          onClick={() => onSelectPreset(color)}
        >
          <div className="flex items-center">
            <div
              className="w-5 h-5 rounded-full mr-2"
              style={{ backgroundColor: color.primary }}
            ></div>
            {color.name}
          </div>
        </Button>
      ))}
    </>
  );
};

export default ColorPresets;
